import React, { useState, useImperativeHandle, useEffect } from 'react'
import styles from './protocolIds-confirm-1.module.scss'
import { Button, Toast } from 'antd-mobile'
import indexApi from '@/apis'
import { TOKEN, ENTER_AGREEMENT, CURRENT_SKIN_INDEX } from '@/constants/storage'
import { parseNum, isPhone, Storage } from '@bihu/common-js'
import { mergeSerialNoIntoHref, pickSerialNo } from '@/utils/utils'
import classNames from 'classnames'
import { useNavigate, useSearchParams } from 'react-router-dom'
import activityApi from '@/apis/activity'

// interface Props{
// }
// 协议确认
export interface Props {
  init?: (obj: any | undefined) => void,
  onSuccess: (obj: any | undefined) => void
  openProtocolsPopup: () => void
  submit: () => void
}
const Success = React.forwardRef(({ init, onSuccess, openProtocolsPopup, submit }: Props, ref: React.ForwardedRef<Props>) => {
  const [isShow, setIsShow] = useState(false)
  const [search] = useSearchParams()

  // 登录传参用的req
  const [reqId, setReqId] = useState('')

  // 切换选中协议
  const checkedTaggle = () => {
    setChecked(!checked)
  }

  // 选择协议
  const [checked, setChecked] = useState(false)
  // 是否抖动
  const [isShake, setIsShake] = useState(false)
  // 按钮loading
  const [btnLoading, setBtnLoading] = useState(false)


  const [youqianlaiProtocol, setYouqianlaiProtocol] = useState<any>('')
  const [otherProtocols, setotherProtocols] = useState([])
  const [quota, setQuota] = useState<any>('')
  const [productName, setProductName] = useState<any>('')
  const [productId, setProductId] = useState<any>('')
  const [pageSerialNo, setPageSerialNo] = useState('')

  init = (obj:any | undefined) => {
    setBtnLoading(false)
    if (obj) {
      setQuota(obj.quota)
      setProductName(obj.productName)
      setYouqianlaiProtocol(obj.youqianlaiProtocol)
      setotherProtocols(obj.otherProtocols)
      setIsShow(true)
      setProductId(obj.productId)
      setPageSerialNo(obj.serialNo || '')
    }
  }

  const close = () => {
    setIsShow(false)
  }

  const checkProtocolsPopup = () => {
    openProtocolsPopup()
  }

  // 暴露内部方法
  useImperativeHandle(ref, () => ({
    init,
    onSuccess,
    openProtocolsPopup,
    submit
  }))

  const submitApplication = () => {
    setBtnLoading(true)
    close()
    submit()
  }

  // 跳转页面
  const openOtherView = (url: string) => {
    Storage.set(ENTER_AGREEMENT, true)
    window.location.href = url
  }

  return (
    <>
      {
        isShow && <section className={styles.modalPage}>
          <div className={styles.main}>
            <img className={styles.modalIcon1} src={require('@imgs/information/modal-icon1.png')} />
            <div className={styles.title}>借款申请匹配成功</div>
            <div className={styles.subTitle}>您确定放弃初审额度吗？</div>
            <div className={styles.contentBox}>
              <div className={styles.productNameBar}>
                <img className={styles.productIcon} src={require('@imgs/information/product.png')} />
                <span>{productName}</span>
              </div>
              <div className={styles.contentItemBar}>
                <div className={styles.contentItemLable}>借款金额（元）</div>
                <div className={styles.contentItemValue} style={{ fontSize: '28px' }}>{ quota }</div>
              </div>
              <div className={styles.contentItemBar}>
                <div className={styles.contentItemLable}>年化利率</div>
                <div className={styles.contentItemValue}>7.2%-24%</div>
              </div>
            </div>
            <div className={styles.textTips}>*最终贷款金额，以第三方机构审核为准</div>
            <div className={styles.btnBox}>
              <Button block loading={btnLoading} loadingText="请等待机构申请结果" className={styles.btn} shape="rounded" color="primary" onClick={() => submitApplication()}>
                立即申请
              </Button>
            </div>
            <div className={styles.protocolIdsBox}>
              <div onClick={() => {
                const path = `/info-audit-agreement?isShowHeader=true&agreementId=${youqianlaiProtocol.id}&title=${encodeURIComponent(youqianlaiProtocol.name)}&productId=${productId}`
                const effectiveSerialNo = pickSerialNo(search.get('serialNo'), pageSerialNo)
                openOtherView(effectiveSerialNo ? mergeSerialNoIntoHref(path, effectiveSerialNo, false) : path)
              }}>《{youqianlaiProtocol.name}》</div>
              {
                otherProtocols.length > 0 && <div onClick={() => checkProtocolsPopup()}>《机构相关协议》</div>
              }
            </div>
          </div>
        </section>
      }
    </>
  )
})

export default Success